/**获取地址参数*/
export function getQueryString(name) {
  const url_string = decodeURIComponent(window.location.href)
  const url = new URL(url_string)
  return url.searchParams.get(name)
}

/**转换日期，避免错误日期传入 */
export const transformDate = (date) => {
  if (date === '' || date === null) {
    return null
  } else {
    const newDate = date instanceof Date ? date : new Date(date)
    if (newDate instanceof Date && !isNaN(newDate.getTime())) {
      return newDate
    } else {
      return null
    }
  }
}

